import { BUY_IN_WAREHOUSE_FACET_VALUE } from '../SearchResultsFacets/constants';

import { ReactNode } from 'react';

import { FilterGroup } from '@/components/FilterGroup';
import { SearchServiceProps } from '@/services/search/types';
import {
    FacetBucketNormalized,
    FacetNormalized,
} from '@/src/components/SearchResultsFacets/types';
import { PageType } from '@/types/pages/search';
import { Box } from '@mui/material';
import { Divider } from '@nxt-costco-com/forge-components';
import type {
    ContentStackEntryDataProps,
    LocaleProps,
} from '@nxt-costco-com/forge-digital-components';

// Facet Label: Hide Unavailable Items
export function ProgramEligibilityFilterGroup({
    facet,
    bopiwFacet,
    bopimFacet,
    facetConfig,
    WarehouseSelectorComponent,
    DeliveryLocationSelectorComponent,
    locale,
    pageType,
    searchService,
}: {
    facet: FacetNormalized;
    bopiwFacet?: FacetNormalized;
    bopimFacet?: FacetNormalized;
    facetConfig: ContentStackEntryDataProps;
    WarehouseSelectorComponent: ReactNode;
    DeliveryLocationSelectorComponent: ReactNode;
    locale: LocaleProps;
    pageType: PageType;
    searchService: SearchServiceProps;
}) {
    let InWarehouseCount = 0;
    const facetBucketsInWarehouseRemoved: FacetBucketNormalized[] = [];
    const facetInWarehouseBucket: FacetBucketNormalized[] = [];

    facet.buckets.forEach((bucket: FacetBucketNormalized) => {
        const bucketValLower = String(bucket.val)?.toLowerCase();
        if (bucketValLower === BUY_IN_WAREHOUSE_FACET_VALUE?.toLowerCase()) {
            InWarehouseCount = bucket.count;
            facetInWarehouseBucket.push(bucket);
        } else {
            facetBucketsInWarehouseRemoved.push(bucket);
        }
    });

    const facetInWarehouseRemoved = {
        ...facet,
        buckets: facetBucketsInWarehouseRemoved,
    };

    const facetInWarehouse = {
        ...facet,
        buckets: facetInWarehouseBucket,
    };

    return (
        <>
            <Divider />
            <Box
                sx={{
                    padding: '10px 0',
                    '& button': { fontSize: 14, textDecoration: 'underline' },
                }}
            >
                {DeliveryLocationSelectorComponent}
            </Box>
            <FilterGroup
                facet={facetInWarehouseRemoved}
                facetConfig={facetConfig}
                locale={locale}
                pageType={pageType}
                searchService={searchService}
            />

            {bopimFacet && (
                <FilterGroup
                    facet={bopimFacet}
                    facetConfig={facetConfig}
                    locale={locale}
                    pageType={pageType}
                    searchService={searchService}
                />
            )}
            {InWarehouseCount > 0 && (
                <>
                    <Box
                        sx={{
                            paddingBottom: '10px',
                            '& button': {
                                fontSize: 14,
                                textDecoration: 'underline',
                            },
                        }}
                        test-id="in-warehouse-wrapper"
                    >
                        {WarehouseSelectorComponent}
                    </Box>
                    <FilterGroup
                        facet={facetInWarehouse}
                        facetConfig={facetConfig}
                        locale={locale}
                        pageType={pageType}
                        searchService={searchService}
                    />
                </>
            )}
            {bopiwFacet && (
                <FilterGroup
                    facet={bopiwFacet}
                    facetConfig={facetConfig}
                    locale={locale}
                    pageType={pageType}
                    searchService={searchService}
                />
            )}
        </>
    );
}
